import React from "react";
import { CircularProgressWithLabel } from "./CircularProgressWithLabel";
import { Stack, Typography } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { getOfficeById } from "../../../api/officeService";
import { bytesToMegaBytes } from "../../../utils/bytestoMegaBytes";
import { storagePercentToColor } from "../../../utils/storagePercentToColor";

export function StorageStatus ({ value = 0, triggerUpdate = null }) {

  const token = localStorage.getItem("accessToken");
  const officeId = jwtDecode(token).active_office_id;
  const [data, setData] = React.useState(null);
  const [percentage, setPercentage] = React.useState(0);

  React.useEffect(() => {
    const fetchData = async () => {
      const data = await getOfficeById(officeId);
      setData(data);
      setPercentage((data.current_bytes / data.allowed_bytes) * 100);
    };
    fetchData();
  }, [triggerUpdate]);

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data ? 
        <>
          <CircularProgressWithLabel value={percentage} color={storagePercentToColor(percentage)}/>
          <Typography variant="caption" color={storagePercentToColor(percentage)}>
            {`${bytesToMegaBytes(data.current_bytes)} MB of ${bytesToMegaBytes(data.allowed_bytes)} MB file storage used`}
          </Typography>
        </>
        : null}
      </Stack>
    </>
  );
}
